import { useEffect, useState } from "react";
import { Ban } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { UnblockButton } from "@/components/profile/BlockUserButton";

export function BlockedUsersSection() {
  const [list, setList] = useState(null);
  const load = () => api.get("/users/blocked").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  return (
    <div className="bg-white rounded-2xl border border-zinc-200 p-4 mb-4" data-testid="blocked-users-section">
      <h2 className="font-display font-bold text-base mb-1 inline-flex items-center gap-2"><Ban size={16} /> Utilizadores bloqueados</h2>
      <p className="text-xs text-zinc-500 leading-relaxed mb-3">Nenhum dos dois vê as publicações, comentários ou perfil do outro, nem pode trocar mensagens. Para bloquear alguém, abre o perfil ou o menu de uma publicação dessa pessoa.</p>
      {list === null && <div className="text-xs text-zinc-400">A carregar…</div>}
      {list?.length === 0 && <div className="text-xs text-zinc-500" data-testid="blocked-users-empty">Não bloqueaste ninguém.</div>}
      {list?.length > 0 && (
        <ul className="divide-y divide-zinc-100">
          {list.map((b) => (
            <li key={b.user_id} className="py-2 flex items-center gap-3" data-testid={`blocked-user-${b.user_id}`}>
              <Avatar src={b.photo_url} name={b.name} size={32} />
              <div className="flex-1 min-w-0 text-sm font-semibold truncate">{b.name}</div>
              <UnblockButton userId={b.user_id} onDone={load} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
